import Vue from 'vue'
import App from './App.vue'
import {store} from '@/store/index.js'
import axios from 'axios'

//
// Import lodash.
//
window._ = require('lodash')

//
// Configure Vue
//
Vue.config.productionTip = false

//
// Configure axios.
//
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'



//
// Import the icons globally. (BootstrapVue components are imported individually
// when needed)
//
import { BootstrapVueIcons } from 'bootstrap-vue'
Vue.use(BootstrapVueIcons)

//
// Create an event bus
//
//import {EventBus} from "./modules/eventbus.js"
import {apiError} from "./modules/errors.js"

//
// Set up a global error handler for Axios.
//
axios.interceptors.response.use(
    function(response) {
        return response
    },
    function(error) {
        if (error.response) {
            apiError(error.response.data.message)
            store.commit("map/setWorking", false)
            return new Promise(() => {})
        }
    }
)

import {patchOl} from "@/modules/patchOl.js"
patchOl()

new Vue({
    store,
    render: h => h(App),
}).$mount('#app')
